var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapTypeRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#92C7E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#92C7E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6EBDA",
    d: "M11.5 11.5V0l9-1 11 8.5-.5 20-16 4L8.5 29V16.5l3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M17.5 30V8L21 3.5m0 0h3m-3 0v-4m5 4h-2m0 0V9m0 18.5V18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5E2BE",
    d: "M18 12v3h3l3-1 6-2.5L28 6l-10 6ZM29 23l1-7-3.5 1.5-2.5.5-2 1h-3l-1 1v3.5h9l2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F0CC4B",
    strokeWidth: 2,
    d: "M.5 20H18l1-1h3l1.5-1 3-.5L31 15M-.5 16h17l2-1h3l2-1 3-.5L31 11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTypeRoad);
export default __webpack_public_path__ + "static/media/mapTypeRoad.c5235a19c819498c4977387b8299f4d6.svg";
export { ForwardRef as ReactComponent };